import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as queryString from 'query-string';

import { sportTypeIds } from '../../../utils/eventConstants';
import { addTrailingSpace, getRatingDetails, setRatingChoice } from '../../../utils';
import { getRatingForTennis, getReturnPageName, getTennisRatingDescription } from './constants';
import { setShowRating, skipPickleballSurveyV2 } from '../../../actions/onboarding-actions';
import { navigateToReturnUrl } from '../../../utils/navigateToReturnUrl';

import styles from '../nuoV2.scss';

const UtrRating = (props) => {
    const { nuo, location } = props;
    const { memberSportTypeIds = [] } = nuo?.data || {};

    const profile = useSelector(({ profile }) => profile);
    const auth = useSelector(({ auth }) => auth);
    const dispatch = useDispatch();

    const parsed = queryString.parse(location.search);
    const hasPickleballType = memberSportTypeIds.includes(sportTypeIds.PICKLEBALL);

    const rating = getRatingDetails(
        setRatingChoice({ player: profile.data }),
        false,
        true,
        false,
        false,
    );
    const tennisRating = getRatingForTennis(rating, profile);

    const isPickleballSurveyIncomplete = !auth?.user?.onboardingCompleted && hasPickleballType && !rating?.pkbRating?.isRated;

    const handleNextClick = () => {
        dispatch(setShowRating(false, null));
    };

    const handleSkipClick = async () => {
        if (isPickleballSurveyIncomplete) {
            await dispatch(skipPickleballSurveyV2());
        }
        dispatch(setShowRating(false, null));
        if (parsed.return) {
            navigateToReturnUrl(props.history, parsed.return);
        } else {
            props.history.push('/');
        }
    };

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.utr-rating.title">
                Your <span className={`${styles.ratingType} ${styles.tennis}`}>UTR</span> tennis rating is :
            </div>
            <div className="row">
                <div className={`col`}>
                    <div className={styles.ratingContainer}>
                        <div className={styles.rating} data-testid="nuo-v2.utr-rating.rating-value">
                            {tennisRating.display}
                        </div>
                        <div className={styles.description} data-testid="nuo-v2.utr-rating.description">
                            Your {addTrailingSpace(tennisRating.prefix)}UTR Rating is {tennisRating.display}. This rating most closely resembles {getTennisRatingDescription(tennisRating.value)} level players. Advance your rating by playing more matches. See you on the courts!
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            {isPickleballSurveyIncomplete && (
                <div className={styles.ratingFooter}>
                    <div className={styles.title} data-testid="nuo-v2.utr-rating.pickleball-prompt">
                        Now let&apos;s get your pickleball rating.
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg text-uppercase"
                        onClick={handleNextClick}
                        data-testid="nuo-v2.utr-rating.get-pickleball-rating-btn"
                    >
                        Get Pickleball Rating
                    </button>
                    <div
                        className="link clickable text-center mt8"
                        onClick={handleSkipClick}
                        data-testid="nuo-v2.utr-rating.skip-link"
                    >
                        {`Not now, take me ${getReturnPageName(parsed?.return)}`}
                    </div>
                </div>
            )}
            {!isPickleballSurveyIncomplete && (
                <div className={styles.ratingFooter}>
                    <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg text-uppercase"
                        onClick={handleNextClick}
                        data-testid="nuo-v2.utr-rating.go-home-btn"
                    >
                        {`Go ${getReturnPageName(parsed?.return)}`}
                    </button>
                </div>
            )}
        </div>
    );
};

export default UtrRating;
